import { Button } from '@mui/material';
import React, { useRef, useEffect } from 'react';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
interface IProps {
  title:string;
  timezone: string;
  CalendarHeaderAction:(type: string, icsString: string) => void;
  hideActions?: boolean;
}
const CalendarHeader = ({ title, timezone, CalendarHeaderAction, hideActions = false }:IProps) => {
  const fileInput = useRef<HTMLInputElement | null>(null);

  const onImportToIcs = () => {
    // `current` points to the mounted file input element
    if (fileInput && fileInput.current) {
      fileInput.current.click();
    }
  };

  const processFileChange = (fileList: FileList) => {
    if (fileList.length === 0) return;
    // only supporting single file upload...multiple files are possible with the drag and drop, so just take the first file...
    const file = fileList.item(0);
    const reader = new FileReader();
    reader.readAsText(file, 'UTF-8');
    reader.onload = (evt) => {
      CalendarHeaderAction('Import', evt.target.result);
    };
    reader.onerror = (evt) => {
      console.error('Unable to read file', evt);
    };

    if (fileInput && fileInput.current) fileInput.current.value = '';
  };

  const updateLiveTime = () => {
    if (timezone) {
      // ouData.timezone = timezone;
      let timeBtn: HTMLElement = document.querySelector('.schedule-overview #timeBtn') as HTMLElement;
      if (timeBtn) {
        timeBtn.innerHTML = '<span class=""></span>' + new Date().toLocaleTimeString('en-US', { timeZone: timezone });
      }
    }
  };

  useEffect(() => {
    const timer = setInterval(() => updateLiveTime(), 1000);
    return function cleanup() {
      clearInterval(timer);
    };
  }, [])

  return (
    <div className="overview-header">
      <div className="overview-titlebar">
        <div className="left-panel">
          <div className="schedule-overview-title" style={{ border: '1px solid transparent' }}>
            {/* EPG Schedule */}
            {title}
          </div>
        </div>
        <div className="center-panel">
          <div>
            {' '}
            All times shown are in <b>{timezone}</b> time
          </div>
          <div className="icon">
            <AccessTimeIcon sx={{ fontSize: '18px', marginLeft: '10px', color: '#fff' }} />
          </div>
          <button id="timeBtn" className="title-bar-btn" disabled={true} content="Time" />
        </div>
        <div className="right-panel">
          {!hideActions ? (
            <>
              <div className="control-panel calendar-export">
                <Button sx={{ mr: 1 }} className="title-bar-btn" onClick={onImportToIcs} >
                  <i aria-hidden="true" className="icon material-icons icon">
                    upload
                  </i>{' '}
                  Import
                </Button>
                <input
                  className="file-input"
                  type="file"
                  id="file"
                  ref={fileInput}
                  onChange={(e) => processFileChange(e.target.files)}
                />
              </div>
              <div className="control-panel calendar-export">
                <Button className="title-bar-btn" onClick={() => CalendarHeaderAction('Export', '')}>
                  <i aria-hidden="true" className="icon material-icons icon">
                    download
                  </i>
                  Export
                </Button>
              </div>
              <div className="control-panel calendar-delete" title='Delete entire EPG schedule'>
                <Button className="title-bar-btn" onClick={() => CalendarHeaderAction('Delete', '')}>
                  <i aria-hidden="true" className="icon material-icons icon">
                    delete
                  </i>
                  Delete
                </Button>
              </div>
              <div className="control-panel"></div>
              <div className="control-panel calendar-export"></div>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default CalendarHeader;
